import { makeLimitedListActions } from 'utils/factory'

const baseTargetPageListActions = makeLimitedListActions('targetPageCustomEvents', {
  storePath: 'targetPage.customEvents',
})
export const fetchTargetPageCustomEvents = baseTargetPageListActions.fetch
export const dropTargetPageCustomEvents = baseTargetPageListActions.drop
